import moment from "moment";

export const getBillingToday = (info) => {
  const storeDate = moment(info?.store_current_date, "YYYY-MM-DD", true);
  return storeDate.isValid() ? storeDate : moment().startOf("day");
};

export const getBillingDaysRemaining = (info) => {
  if (!info?.next_payment_date) return null;
  const nextPaymentDate = moment(info.next_payment_date, "YYYY-MM-DD", true);
  if (!nextPaymentDate.isValid()) return null;
  return nextPaymentDate.diff(getBillingToday(info), "days") + 1;
};

export const canOpenBillingSections = (info) => {
  if (!info) return false;
  if (!info.next_payment_date) return true;
  const nextPaymentDate = moment(info.next_payment_date, "YYYY-MM-DD", true);
  if (!nextPaymentDate.isValid()) return false;
  return nextPaymentDate
    .add(info.grace_period || 0, "days")
    .isSameOrAfter(getBillingToday(info), "day");
};
